import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { pageSEO } from './utils/seoConfig';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustedCompanies from './components/TrustedCompanies';
import Benefits from './components/Benefits';
import Solutions from './components/Solutions';
import InterfaceGallery from './components/InterfaceGallery';
import Services from './components/Services';
import Industries from './components/Industries';
import UseCases from './components/UseCases';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import SuccessCases from './components/SuccessCases';
import ModuleDetails from './components/ModuleDetails';
import DemoRequest from './components/DemoRequest';
import SolutionsPage from './components/SolutionsPage';
import ServicesPage from './components/ServicesPage';
import IndustriesPage from './components/IndustriesPage';
import AboutPage from './components/AboutPage';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import BlogCategory from './components/BlogCategory';
import BlogTeaser from './components/BlogTeaser';
import SEOHead from './components/SEOHead';
import ROICalculator from './components/ROICalculator';
import { getOrganizationStructuredData, getSoftwareApplicationStructuredData, getWebSiteStructuredData } from './utils/structuredData';

function HomePage() {
  const { language } = useLanguage();
  const seo = pageSEO.home;

  const combinedStructuredData = [
    getOrganizationStructuredData(),
    getSoftwareApplicationStructuredData(),
    getWebSiteStructuredData()
  ];

  return (
    <>
      <SEOHead
        title={seo.title[language]}
        description={seo.description[language]}
        keywords={seo.keywords[language]}
        structuredData={combinedStructuredData}
        url="/"
      />
      <Header />
      <main>
        <Hero />
        <TrustedCompanies />
        <Benefits />
        <Solutions />
        <InterfaceGallery />
        <UseCases />
        <ROICalculator />
        <BlogTeaser />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <div className="min-h-screen bg-white flex flex-col">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/solutions" element={
                <>
                  <SolutionsPage />
                  <ScrollToTop />
                </>
              } />
              <Route path="/services" element={
                <>
                  <ServicesPage />
                  <ScrollToTop />
                </>
              } />
              <Route path="/industries" element={
                <>
                  <IndustriesPage />
                  <ScrollToTop />
                </>
              } />
              <Route path="/about" element={
                <>
                  <AboutPage />
                  <ScrollToTop />
                </>
              } />
              <Route path="/privacy" element={
                <>
                  <PrivacyPolicy />
                  <ScrollToTop />
                </>
              } />
              <Route path="/terms" element={
                <>
                  <TermsOfService />
                  <ScrollToTop />
                </>
              } />
              <Route path="/cookies" element={
                <>
                  <CookiePolicy />
                  <ScrollToTop />
                </>
              } />
              <Route path="/success-cases" element={
                <>
                  <SuccessCases />
                  <ScrollToTop />
                </>
              } />
              <Route path="/module/:moduleId" element={
                <>
                  <ModuleDetails />
                  <ScrollToTop />
                </>
              } />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/category/:categorySlug" element={<BlogCategory />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/demo" element={
                <>
                  <DemoRequest />
                  <ScrollToTop />
                </>
              } />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;